import React, { Component } from 'react';
import { connect } from 'react-redux';

import { findKey, getDateFormatted, getRevDate, getDateForSrch, fetchGet } from '../../common/common';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
// import store from '../../store';

import Auto from '../autocomplete/autocomplete';

class Modify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prevLink: '',
            nextLink: '',
            from: this.props.search.searchParams.fromCity.split('|')[1],
            to: this.props.search.searchParams.toCity.split('|')[1],
            cityList: {},
            fromList: [],
            toList: [],
            depDate: moment(new Date(getRevDate(this.props.search.searchParams.departDate))),
            retDate: this.props.search.searchParams.mode === 'oneway' ? null : moment(new Date(getRevDate(this.props.search.searchParams.returnDate))),
            focused: false,
            retFocused: false,
            fromErr: false,
            toErr: false,
            depErr: false,
            swapErr: false
        }
    }

    componentDidMount() {
        const that = this;
        const url = window.url + '/api/resource/getCities';
        fetchGet(url).then(function(data) {
            const cityList = data;
            let fromList = [];
            let toList = [];
            Object.keys(data).forEach((el,index) => {
                fromList.push(data[el].Name);
                const fromCityKey = Object.keys(cityList).find(key => cityList[key].Name === that.props.search.searchParams.fromCity.split('|')[1]);
                if (el === fromCityKey) {
                    Object.keys(data[el].ToCities).forEach(val => toList.push(data[el].ToCities[val]));
                }
            })
            that.setState({ cityList, fromList, toList });
        }).catch(function(error) {
            console.log(error);
        });
        this.parseNextPrevLinks()
    }

    parseNextPrevLinks = () => {
        const departDate = new Date(getRevDate(this.props.search.searchParams.departDate));
        const currDate = new Date(new Date().toDateString());
        let tomorrow = new Date(departDate);
        let yesterday = new Date(departDate);
        tomorrow.setDate(departDate.getDate() + 1);
        yesterday.setDate(departDate.getDate() - 1);

        const prevLink = currDate < yesterday ? this.getSearchUrl(yesterday) : false;
        const nextLink = this.getSearchUrl(tomorrow);
        this.setState({ prevLink, nextLink });
    }

    getSearchUrl = (val) => {
        const dt = 'departDate=' + this.getFormattedDateForURL(val);
        let srchUrl = '/search/';
        const srchParams = window.location.search;
        let tempDt = srchParams.indexOf('departDate=') >= 0 ? srchParams.split('departDate=') : false;
        tempDt[1] = tempDt[1].indexOf('&') >= 0 ? tempDt[1].substr(tempDt[1].indexOf('&')) : '';
        srchUrl += tempDt[0] + dt + tempDt[1];
        return srchUrl;
    }

    getFormattedDateForURL = (dateString) => {
        //dateString = dateString.replace(/-/g, ' '); //firefox doesn't understand hyphens in date
        const d = dateString;
        let day = d.getDate(),
            month = d.getMonth() + 1,
            year = d.getFullYear();

        if (day < 10) day = '0' + day;
        if (month < 10) month = '0' + month;
        
        return day + '-' + month + '-' + year;
    }

    setFrom = (from, param) => {
        let toList = param ? [] : this.state.toList;
        if (param) {
            const cityList = this.state.cityList;
            if (from === '') {
                const list = cityList[Object.keys(cityList)[0]].ToCities;
                Object.keys(list).forEach(el => toList.push(list[el]));
            } else {
                const key = findKey(cityList, from, 'Name');
                const list = cityList[key].ToCities;
                Object.keys(list).forEach(el => toList.push(list[el]));
            }
        }
        if (param === 'true') {
            if (toList.indexOf(this.state.from) === -1) {
                from = this.state.from;
                const to = this.state.to;
                toList = this.state.toList;
                this.setState({ from, toList, to, swapErr: true });
                alert(to + ' to ' + from + ' route is not available.');
            } else {
                this.setState({ from, toList, to: this.state.from });
            }
        } else {
            this.setState({ from, toList, to: toList[0] });
        }
    }

    setTo = (to, param) => {
        this.setState({ to });
    }

    checkOutsideRange = (param, e) => {
        let today = new Date();
        today.setHours(0,0,0,0)
        let ninety = new Date();
        ninety = ninety.setDate(ninety.getDate() + 90);
        if (param === 'dep') {
            return !(today <= e._d && ninety > e._d);
        } else {
            if (this.state.depDate && this.state.depDate._d) {
                const depDate = this.state.depDate._d;
                return !(depDate < e._d && ninety > e._d);
            } else {
                return !(today < e._d && ninety > e._d);
            }
        }
    }

    swapCities = () => {
        // const from = this.state.from;
        const to = this.state.to;
        this.setFrom(to, 'true');
        // this.setTo('', false);
    }

    modifySrch = () => {
        const from = this.state.from;
        const to = this.state.to;
        const departDate = this.state.depDate ? this.state.depDate._d : false;
        const returnDate = this.state.retDate ? this.state.retDate._d : false;

        if (!from || !to || !departDate) {
            let fromErr = !from ? true : false;
            let toErr = !to ? true : false;
            let depErr = !departDate ? true : false;
            this.setState({ fromErr, toErr, depErr });
            return;
        } else {
            const mode = !returnDate ? 'oneway' : 'roundtrip';
            const fromCityKey = Object.keys(this.state.cityList).find(key => this.state.cityList[key].Name === from);
            const fromCity = fromCityKey + '|' + from;
            const toCity = Object.keys(this.state.cityList[fromCityKey].ToCities).find(key => this.state.cityList[fromCityKey].ToCities[key] === to) + '|' + to;
            const depD = getDateForSrch(departDate);
            const retD = !returnDate ? '' : '&returnDate=' + getDateForSrch(returnDate);
            let url = '/search?mode=' + mode + '&fromCity=' + fromCity + '&toCity=' + toCity + '&departDate=' + depD + retD;
            window.location.href = url;
        }
    }

    render() {
        const prms = this.props.search.searchParams;
        return (
            <section style = { this.modifyS }>
                <div style = { this.modUpS }>
                    <Auto
                        style = { this.inModifyS }
                        list = { this.state.fromList }
                        placeholder = 'From'
                        padding = { false }
                        value = { this.state.from }
                        setValue = { this.setFrom }
                        err = { this.state.fromErr }
                    />
                    <div className = 'swap-ico' onClick = { this.swapCities }><span></span><span></span></div>
                    <Auto
                        style = { this.inModifyS }
                        list = { this.state.toList }
                        placeholder = 'To'
                        padding = { true }
                        value = { this.state.to }
                        setValue = { this.setTo }
                        err = { this.state.toErr }
                    />
                    <div className = {this.state.depErr ? 'mo-inp err' : 'mo-inp'}>
                        <SingleDatePicker
                            date = { this.state.depDate } // momentPropTypes.momentObj or null
                            onDateChange = { depDate => this.setState({ depDate, retDate: null })} // PropTypes.func.isRequired
                            focused = { this.state.focused } // PropTypes.bool
                            onFocusChange = { ({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                            hideKeyboardShortcutsPanel = {true}
                            block = {true}
                            numberOfMonths = { 1 }
                            noBorder = { true }
                            displayFormat = 'ddd, DD MMM YY'
                            placeholder = 'Onward'
                            isOutsideRange = { (event) => this.checkOutsideRange('dep', event) }
                            />
                        { this.state.depDate ? <span className = 'mod-clear dt' onClick = { () => this.setState({ depDate: null, focused: true}) }>&#x2715;</span> : '' }
                    </div>
                    <div className = 'mo-inp'>
                        <SingleDatePicker
                            date = { this.state.retDate } // momentPropTypes.momentObj or null
                            onDateChange = { retDate => this.setState({ retDate })} // PropTypes.func.isRequired
                            focused = { this.state.retFocused } // PropTypes.bool
                            onFocusChange = { ({ focused: retFocused }) => this.setState({ retFocused })} // PropTypes.func.isRequired
                            hideKeyboardShortcutsPanel = {true}
                            block = {true}
                            numberOfMonths = { 1 }
                            noBorder = { true }
                            displayFormat = 'ddd, DD MMM YY'
                            placeholder = 'Return'
                            isOutsideRange = { (event) => this.checkOutsideRange('ret', event) }
                        />
                        { this.state.retDate ? <span className = 'mod-clear dt' onClick = { () => this.setState({ retDate: null, retFocused: true}) }>&#x2715;</span> : '' }
                    </div>
                    <div style = { this.modBtnS } onClick = { this.modifySrch }>
                        MODIFY
                    </div>
                </div>
                <div className = 'mod-down'>
                    <div>{ prms && prms.fromCity ? prms.fromCity.split('|')[1] : '' } to { prms && prms.toCity ? prms.toCity.split('|')[1] : '' } on { prms && prms.departDate ? getDateFormatted(prms.departDate) : '' }</div>
                    <div>
                        {
                            this.state.prevLink ? 
                            <a href = { this.state.prevLink }>Previous Day</a>
                            : ''
                        }
                        { this.state.prevLink ? ' | ' : '' }
                        <a href = { this.state.nextLink }>Next Day</a>
                    </div>
                </div>
            </section>
        );
    }

    modifyS = {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: '15px 6%',
        background: window.color.searchBoxBgColor,
        color: '#fff'
    }

    modUpS = {
        position: 'relative',
        display: 'flex',
        background: '#fff',
        borderRadius: '3px'
    }

    modDownS = {
        position: 'relative',
        display: 'flex',
        padding: '15px 0 0',
        fontSize: '0.8rem'
    }

    inModifyS = {
        position: 'relative',
        width: '25%'
    }

    modBtnS = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '10%',
        background: window.color.buttonColor,
        borderRadius: '0 3px 3px 0',
        cursor: 'pointer'
    }
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Modify);